import React from "react";
import { AxiosGetSecretApi, AxiosPostSecretApi } from "../../../utils/fetchApi";
import MainLayout from "../../../components/Layout/MainLayout";
import { Form, Input, Select, Button, message } from "antd";
import CustomPopconfirm from "../../../components/CustomsAntd/CustomPopconfirm";
import Card from "../../../components/Card";
import "./quan-ly-tai-khoan.scss";
class CreateUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: undefined,
      fullname: undefined,
      password: undefined,
      re_password: undefined,
      role: undefined,
      department: undefined,

      listRole: [],
      listDepartment: [],

      isLoading: false,
    };
    this.form = React.createRef();
  }

  componentDidMount() {
    this.getAllSelectData();
  }

  async getAllSelectData() {
    let [listDepartment] = await Promise.all([
      AxiosGetSecretApi(`/api/user/phongban`),
    ]);

    this.setState({
      listDepartment,
    });
  }

  async handleSubmit() {
    this.setState({ isLoading: true });
    this.form.current
      .validateFields()
      .then((e) => {
        let data = {
          HoVaTen: e.fullname,
          Permistion: e.role,
          name: e.username,
          password: e.password,
          valuePhongBan: e.department,
        };
        this.createUser(data);
      })
      .catch(this.setState({ isLoading: false }));
  }

  async createUser(data) {
    let response = await AxiosPostSecretApi("/api/user/create", data);
    if (response.success) {
      setTimeout(() => {
        this.props.history.push("/ql-nguoi-dung");
      }, 1000);
      message.success("Tạo mới người dùng thành công");
    } else {
      if (response.message) {
        message.error(response.message);
      } else {
        message.error("Tạo mới người dùng không thành công");
      }
    }
    this.setState({ isLoading: false });
  }

  render() {
    return (
      <MainLayout {...this.props} title={"Quản lý người dùng"}>
        <div className="page-with-card">
          <Card title="Quản lý người dùng">
            <div className="create-user">
              <div className="content">
                <Form
                  onSubmit={this.handleSubmit}
                  style={{ width: "600px" }}
                  layout="vertical"
                  ref={this.form}
                >
                  <div className="sub-title">Tạo mới người dùng</div>
                  <Form.Item
                    label="Tên đăng nhập"
                    style={{ marginBottom: "18px" }}
                    initialValue={this.state.username}
                    name="username"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập tên đăng nhập!",
                      },
                      {
                        message: "Vui lòng kiểm tra lại tên đăng nhập!",
                        pattern: new RegExp(
                          "^[a-zA-Z0-9]([._](?![._])|[a-zA-Z0-9]){0,50}[a-zA-Z0-9]$",
                          "g"
                        ),
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input className="input" />
                  </Form.Item>

                  <Form.Item
                    label="Họ và tên"
                    style={{ marginBottom: "18px" }}
                    initialValue={this.state.fullname}
                    name="fullname"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập họ và tên!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input className="input" autoComplete="off" />
                  </Form.Item>

                  <Form.Item
                    label="Mật khẩu"
                    style={{ marginBottom: "18px" }}
                    initialValue={this.state.password}
                    hasFeedback
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập mật khẩu!",
                      },
                      {
                        pattern: new RegExp(
                          "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$",
                          "g"
                        ),
                        message:
                          "Tối thiểu tám ký tự, ít nhất một chữ cái viết hoa, một chữ cái viết thường, một số và một ký tự đặc biệt",
                      },
                    ]}
                  >
                    <Input.Password
                      autoComplete="new-password"
                      className="input"
                    />
                  </Form.Item>

                  <Form.Item
                    name="confirm"
                    label="Xác nhận Mật khẩu"
                    style={{ marginBottom: "18px" }}
                    dependencies={["password"]}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập lại mật khẩu!",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error("Mật khẩu không khớp !")
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      autoComplete="new-password"
                      className="input"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Quyền"
                    style={{ marginBottom: "18px" }}
                    initialValue={this.state.role}
                    name="role"
                    hasFeedback
                    rules={[
                      { required: true, message: "Vui lòng chọn quyền!" },
                    ]}
                  >
                    <Select className="select" showSearch optionFilterProp = "name">
                      <Select.Option value="QuanTri" name = "Quản trị hệ thống">
                        Quản trị hệ thống
                      </Select.Option>
                      <Select.Option value="ChuyenVien" name = "Chuyên viên">
                        Chuyên viên
                      </Select.Option>
                      <Select.Option value="LanhDao" name = "Lãnh đạo">Lãnh đạo</Select.Option>
                      <Select.Option value="Khac" name = "Khác">Khác</Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label="Phòng ban"
                    style={{ marginBottom: "18px" }}
                    initialValue={this.state.department}
                    name="department"
                    hasFeedback
                    rules={[
                      { required: true, message: "Vui lòng phòng ban !" },
                    ]}
                  >
                    <Select className="select" showSearch optionFilterProp = "name">
                      {this.state.listDepartment.map((e, i) => (
                        <Select.Option value={e.MaPhongBan} key={i} name = {e.MoTa}>
                          {e.MoTa}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <CustomPopconfirm
                    title={"Bạn có chắc muốn tạo mới?"}
                    okText="Có"
                    cancelText="Không"
                    content={
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Button
                          className="button-create-user"
                          loading={this.state.isLoading}
                          onClick={() => {}}
                          type="primary"
                        >
                          Tạo mới
                        </Button>
                      </div>
                    }
                    onConfirm={(e) => this.handleSubmit(e)}
                  />
                </Form>
              </div>
            </div>
          </Card>
        </div>
      </MainLayout>
    );
  }
}
export default CreateUser;
